/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCategoryDetails } from 'actions/categoryDetailsAction';
import FSBModal from 'components/common/FSBModal';
import CategoriesDetails from './components/CategoriesDetails';

const CategoryDetailsDrawer = () => {
  const dispatch = useDispatch();
  const { status, selectedCategory } = useSelector(
    (state) => state.categoryDetailsReducer,
  );
  const drawerToggle = () => {
    dispatch(setCategoryDetails({ status: false, selectedCategory: null }));
  };

  useEffect(() => {
    dispatch(setCategoryDetails({ status: false, selectedCategory: null }));
  }, []);

  window.addEventListener('popstate', () => {
    drawerToggle();
  });

  return (
    <div>
      {' '}
      {status && (
        <FSBModal
          size="xl"
          title="Categories Details"
          open={status}
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          message=""
          modalClass="right-drawer right-drawer-details"
        >
          <CategoriesDetails categoryId={selectedCategory.id} />
        </FSBModal>
      )}
    </div>
  );
};

export default CategoryDetailsDrawer;
